export default __webpack_public_path__ + "static/media/telugu_gen_f.33269477.wav";